export const REQUEST_ACTIVITY_TYPES_KEPT_AFTER_ACCEPT = ["Contact Updated"];

const doneOnMillis = (item) => {
  const millis = Date.parse(item?.activity_done_on);
  return Number.isNaN(millis) ? Number.NEGATIVE_INFINITY : millis;
};

const newestFirst = (a, b) => {
  const left = doneOnMillis(a);
  const right = doneOnMillis(b);
  if (left === right) return 0;
  return left < right ? 1 : -1;
};

/** Merges VQA-level activity with the request-level rows kept visible after acceptance. */
export const mergeAcceptedActivityFeed = (vqaItems, requestItems) => {
  const kept = (requestItems ?? []).filter((item) =>
    REQUEST_ACTIVITY_TYPES_KEPT_AFTER_ACCEPT.includes(item?.activity_type)
  );
  return [...(vqaItems ?? []), ...kept].sort(newestFirst);
};
